<template>
  <div class="chouqian-container">
    <div class="header-section">
      <h1 class="magic-title">喵星君大大——抽签</h1>
      <p class="subtitle">点击抽签按钮，答案尽在其中</p>
    </div>
    <div class="draw-section">
      <button
        :disabled="loading"
        @click="drawLot"
        class="draw-btn"
      >
        <span v-if="!loading">✨ {{ loading ? '抽签中...' : '点击抽签' }} ✨</span>
        <span v-else>🔮 正在召唤神秘力量...</span>
      </button>
    </div>
    <transition name="fade">
      <div v-if="result" class="result-section">
        <div class="gua-card">
          <div class="gua-header">
            <h2 class="gua-title">{{ result.guaname.name }} <span class="gua-number">第{{ result.guaname.num }}卦</span></h2>
            <div class="divider"></div>
          </div>
          <p class="gua-interpre">{{ result.guaname.interpre }}</p>
        </div>
        <div class="splgua-section">
          <div class="splgua-box nei-gua">
            <div class="gua-symbol-container">
              <span class="gua-symbol">{{ result.splgua.nei.symbol }}</span>
            </div>
            <h3>内卦</h3>
            <p class="gua-info">卦序：{{ result.splgua.nei.guanum }}</p>
            <p class="gua-word">{{ result.splgua.nei.word }}</p>
          </div>
          <div class="splgua-box wai-gua">
            <div class="gua-symbol-container">
              <span class="gua-symbol">{{ result.splgua.wai.symbol }}</span>
            </div>
            <h3>外卦</h3>
            <p class="gua-info">卦序：{{ result.splgua.wai.guanum }}</p>
            <p class="gua-word">{{ result.splgua.wai.word }}</p>
          </div>
        </div>
        <div class="tdr-section">
          <h3 class="tdr-title">运势解读</h3>
          <div class="tdr-grid">
            <div class="tdr-item">
              <span class="tdr-icon">🍀</span>
              <div>
                <p class="tdr-label">天时</p>
                <p class="tdr-value">{{ result.tdr.lucky }}</p>
              </div>
            </div>
            <div class="tdr-item">
              <span class="tdr-icon">👤</span>
              <div>
                <p class="tdr-label">人和</p>
                <p class="tdr-value">{{ result.tdr.person }}</p>
              </div>
            </div>
            <div class="tdr-item">
              <span class="tdr-icon">🔮</span>
              <div>
                <p class="tdr-label">地利</p>
                <p class="tdr-value">{{ result.tdr.prop }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-section">
          <div class="custom-alert">
            <span class="alert-icon">💡</span>
            <div class="alert-content">
              <p class="alert-title">提示</p>
              <p>{{ result.tip.tip }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="showError" class="custom-dialog">
      <div class="dialog-mask"></div>
      <div class="dialog-content">
        <div class="dialog-header">
          <h3 class="dialog-title">神秘力量受阻</h3>
          <button class="dialog-close" @click="showError = false">×</button>
        </div>
        <div class="dialog-body">
          <div class="error-icon">⚡</div>
          <p>{{ errorMsg }}</p>
          <button class="retry-btn" @click="drawLot">再次尝试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {postAction} from '@/api/manage'
export default {
  name: 'ChouQian',
  data() {
    return {
      loading: false,
      result: null,
      showError: false,
      errorMsg: '',
    };
  },
  methods: {
    async drawLot() {
      this.loading = true;
      this.result = null;
      try {
        const res = await postAction('https://online.miaoxingjundd.com/api/harmony/chouqian', {});
        if (res.data.code === 200 && res.data.msg) {
          this.result = res.data.msg;
        } else {
          this.errorMsg = res.data.msg || '神秘力量暂时无法响应，请稍后再试';
          this.showError = true;
        }
      } catch (e) {
        this.errorMsg = '与神秘世界的连接中断，请稍后重试';
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=ZCOOL+KuaiLe&display=swap');

/* 全局样式变量 - 从magic-draw.html完整迁移 */
:root {
  --primary-gradient: linear-gradient(135deg, #ff4081 0%, #ff9100 100%);
  --primary-light: rgba(255, 64, 129, 0.1);
  --shadow-soft: 0 5px 15px rgba(0, 0, 0, 0.05);
  --shadow-medium: 0 8px 25px rgba(255, 64, 129, 0.4);
  --shadow-strong: 0 12px 30px rgba(255, 64, 129, 0.6);
  --radius-small: 12px;
  --radius-medium: 16px;
  --radius-large: 20px;
  --radius-full: 50px;
  --transition-normal: all 0.3s ease;
}

.chouqian-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #fce4ec 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px 40px;
  font-family: 'Ma Shan Zheng', cursive;
  position: relative;
  overflow: hidden;
}

/* 添加从magic-draw.html迁移的背景装饰元素 */
.chouqian-container::before,
.chouqian-container::after {
  content: ""; 
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(255, 192, 203, 0.1);
  border-radius: 50%;
  z-index: 0;
}

.chouqian-container::before {
  top: -150px;
  right: -150px;
}

.chouqian-container::after {
  bottom: -100px;
  left: -100px;
}

.header-section {
  margin-top: 40px;
  text-align: center;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.magic-title {
  font-size: 3.2rem;
  color: #ff4081;
  letter-spacing: 0.1em;
  font-family: 'ZCOOL KuaiLe', cursive;
  text-shadow: 0 2px 10px rgba(255, 105, 180, 0.3);
  margin-bottom: 8px;
  background: linear-gradient(to right, #ff4081, #ff9100);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  animation: titleShine 3s ease-in-out infinite;
}

/* 添加标题动画效果 */
@keyframes titleShine {
  0%, 100% { text-shadow: 0 2px 10px rgba(255, 105, 180, 0.3); }
  50% { text-shadow: 0 5px 20px rgba(255, 64, 129, 0.6); }
}

.magic-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(to right, #ff4081, #ff9100);
  border-radius: 2px;
}

.subtitle {
  color: #666;
  font-size: 1.1rem;
  margin-top: 16px;
  margin-bottom: 40px;
  font-family: 'Ma Shan Zheng', cursive;
  letter-spacing: 1px;
}

.draw-section {
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}

.draw-btn {
  font-size: 1.3rem;
  padding: 18px 60px;
  background: var(--primary-gradient);
  border: none;
  border-radius: var(--radius-full);
  color: black;
  cursor: pointer;
  box-shadow: var(--shadow-medium);
  transition: var(--transition-normal);
  font-family: 'Ma Shan Zheng', cursive;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
}

.draw-btn::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 60%);
  transform: rotate(30deg);
  transition: all 0.3s;
}

.draw-btn:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-strong);
}

.draw-btn:hover::before {
  left: 100%;
}

.draw-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: var(--shadow-medium);
}

.result-section {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  background: #fff;
  border-radius: var(--radius-large);
  box-shadow: 0 10px 40px rgba(255, 105, 180, 0.15);
  padding: 30px 25px;
  margin-top: 20px;
  animation: fadeIn 0.8s;
  border: 1px solid rgba(255, 192, 203, 0.3);
  position: relative;
  z-index: 1;
}

.gua-card {
  background: linear-gradient(135deg, #fff5f7 0%, #fff 100%);
  border-radius: var(--radius-medium);
  padding: 25px 20px;
  margin-bottom: 25px;
  box-shadow: 0 5px 15px rgba(255, 182, 193, 0.1);
  position: relative;
  overflow: hidden;
}

.gua-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #ff4081, #ff9100);
}

/* 以下为保持不变的现有样式，确保完整性 */
.gua-header {
  margin-bottom: 15px;
}

.gua-title {
  color: #ff4081;
  font-size: 1.8rem;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.gua-number {
  font-size: 1rem;
  background: linear-gradient(to right, #ff4081, #ff9100);
  color: white;
  padding: 3px 12px;
  border-radius: 20px;
  margin-left: 10px;
}

.divider {
  height: 2px;
  background: linear-gradient(to right, rgba(255, 64, 129, 0.2), rgba(255, 64, 129, 0.8), rgba(255, 64, 129, 0.2));
  margin: 10px 0;
}

.gua-interpre {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  text-align: justify;
}

.splgua-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  gap: 15px;
}

.splgua-box {
  flex: 1;
  background: #fff;
  border-radius: 14px;
  padding: 20px 15px;
  box-shadow: var(--shadow-soft);
  text-align: center;
  transition: var(--transition-normal);
  border: 1px solid rgba(255, 192, 203, 0.3);
}

.splgua-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(255, 105, 180, 0.2);
}

.nei-gua {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
}

.wai-gua {
  background: linear-gradient(135deg, #fff9f9 0%, #fff 100%);
}

.gua-symbol-container {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fff5f7 0%, #ffeef1 100%);
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(255, 105, 180, 0.1);
}

.gua-symbol {
  font-size: 2.2rem;
  color: #ff4081;
}

.gua-info {
  color: #888;
  font-size: 0.9rem;
  margin: 8px 0;
}

.gua-word {
  color: #555;
  font-size: 1rem;
  line-height: 1.5;
}

.tdr-section {
  background: #fff9f9;
  border-radius: var(--radius-medium);
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: var(--shadow-soft);
}

.tdr-title {
  color: #ff4081;
  font-size: 1.3rem;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
}

.tdr-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #ff4081, #ff9100);
  border-radius: 3px;
}

.tdr-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.tdr-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s ease;
}

.tdr-item:hover {
  transform: translateY(-3px);
}

.tdr-icon {
  font-size: 1.5rem;
  margin-right: 10px;
  color: #ff4081;
}

.tdr-label {
  color: #888;
  font-size: 0.8rem;
  margin-bottom: 3px;
}

.tdr-value {
  color: #555;
  font-size: 0.95rem;
  font-weight: bold;
}

.tip-section {
  margin-top: 20px;
}

.custom-alert {
  background: linear-gradient(135deg, #fff9f9 0%, #fff 100%);
  border-radius: 14px;
  padding: 18px 20px;
  display: flex;
  align-items: flex-start;
  box-shadow: var(--shadow-soft);
  border-left: 4px solid #ff4081;
  animation: alertPulse 4s infinite;
}

/* 添加提示框脉动效果 */
@keyframes alertPulse {
  0%, 100% { box-shadow: var(--shadow-soft); }
  50% { box-shadow: 0 5px 20px rgba(255, 105, 180, 0.2); }
}

.alert-icon {
  font-size: 1.8rem;
  margin-right: 15px;
  color: #ff4081;
}

.alert-content {
  flex: 1;
}

.alert-title {
  color: #ff4081;
  font-size: 1.1rem;
  margin-bottom: 5px;
  font-weight: bold;
}

.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  animation: maskFade 0.5s ease;
}

@keyframes maskFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dialog-content {
  background-color: white;
  border-radius: var(--radius-medium);
  width: 320px;
  position: relative;
  z-index: 1;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: dialogScale 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes dialogScale {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.dialog-header {
  padding: 18px 20px;
  background: var(--primary-gradient);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: bold;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: white;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.dialog-close:hover {
  opacity: 1;
}

.dialog-body {
  padding: 25px 20px;
  text-align: center;
}

.error-icon {
  font-size: 3rem;
  color: #ff4081;
  margin-bottom: 15px;
  animation: errorShake 1s ease-in-out;
}

@keyframes errorShake {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-15deg); }
  75% { transform: rotate(15deg); }
}

.retry-btn {
  margin-top: 20px;
  padding: 10px 25px;
  background: var(--primary-gradient);
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'Ma Shan Zheng', cursive;
  font-size: 1rem;
  box-shadow: 0 4px 10px rgba(255, 64, 129, 0.3);
  transition: all 0.3s;
}

.retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(255, 64, 129, 0.4);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 600px) {
  .magic-title {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .draw-btn {
    padding: 15px 40px;
    font-size: 1.1rem;
  }
  
  .splgua-section {
    flex-direction: column;
  }
  
  .tdr-grid {
    grid-template-columns: 1fr;
  }
}
</style>